import { Box } from '~/eds/src/components/Box/Box';
import { LoadingShimmer } from '~/eds/src/components/LoadingShimmer/LoadingShimmer';
import { lineHeights } from '~/eds/src/system/theme/lineHeights';
import { typography } from '~/eds/src/tokens/typography';

export const TaskLoading = () => {
  return (
    <Box as="div" borderRadius="m" px={4} py={2} mb={2} w="100%">
      <LoadingShimmer
        width="100%"
        height={
          lineHeights[typography.body.lineHeight as keyof typeof lineHeights]
        }
      />
    </Box>
  );
};
